module.exports = __webpack_public_path__ + "img/Games-low.63c2dacd.jpg";